import VueRouter, { RouteConfig } from 'vue-router'

const Index = () => import('../activity/lesson-plan-collection/Index.vue')

export const lessonPlanCollectionRoute: RouteConfig = {
  path: '/lesson-plan-collection',
  name: 'lesson_plan_collection',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '教案资源征集令',
    ignoreLogin: true,
  },
}

export default [lessonPlanCollectionRoute]

export function navigateToLessonPlanCollection(router: VueRouter) {
  router.push({ name: lessonPlanCollectionRoute.name })
}
